import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "supplier-home-page",
  templateUrl: "./supplier-home.page.html",
  styleUrls: ["./supplier-home.page.scss", "./supplier-home.mobile.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplierHomePage {
  constructor(private _titleService: Title) {
    this._titleService.setTitle('SpaceX - Suppliers');
  }
}
